import produce from "immer"
import { ASC } from "const"
import { MarkovTransition } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovTransition: MarkovTransition = {
    id: null,
    modelId: null,
    stateFrom: null,
    stateTo: null,
    expression: "",
    order: 0,
}

const initMarkovTransitionState: types.MarkovTransitionState = {
    transitionList: {},
    transitionIds: [],
    transitionEdit: initMarkovTransition,

    calculatedExpressions: {},

    sortColumn: "order",
    sortOrder: ASC,

    reloadList: true,
    reloadEdit: true,
}

const markovTransitionReducer = produce((
    draft: types.MarkovTransitionState = initMarkovTransitionState,
    action: ActionTypes = null,
): types.MarkovTransitionState => {
    switch (action.type) {
        case types.MARKOV_TRANSITION_LIST:
            draft.transitionList = action.transitionList
            return draft

        case types.MARKOV_TRANSITION_IDS:
            draft.transitionIds = action.transitionIds
            return draft

        case types.MARKOV_TRANSITION_EDIT:
            draft.transitionEdit = action.transition
            return draft

        case types.MARKOV_TRANSITION_CALCULATED_EXPRESSIONS:
            draft.calculatedExpressions = action.calcualted
            return draft

        case types.MARKOV_TRANSITION_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_TRANSITION_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_TRANSITION_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovTransitionReducer
